import { Icon } from 'ui/components/primitives';
import { slugify } from 'core/utilities/strings/slugify';

import { BreadcrumbMobile } from './BreadcrumbsMobile';
import { Breadcrumbs } from './Breadcrumbs.styles';
import { Trail, Step, StepLink } from './components';
import type { BreadcrumbProps } from './Breadcrumbs.d';

const BreadcrumbBase = ({
  desktop = false,
  disabled,
  homePath,
  tracks = [],
  ...props
}: BreadcrumbProps) => {
  const currentPath = tracks[tracks.length - 1];
  const previousPaths = tracks.filter((_el, index) => index !== tracks.length - 1);
  const trackBreadcrumb = () => {
    window.dataLayer.push({
      event: 'analytics-event',
      event_parameters: {
        cd_section: slugify(currentPath?.name),
        event_name: 'interaction_breadcrumb',
        cd_interaction_detail: slugify(`click:home}`),
      },
    });
  };

  return (
    <Breadcrumbs.Component aria-label="Breadcrumb" data-testid="breadcrumbs" {...props}>
      <Breadcrumbs.List>
        <Step data-disabled={disabled} data-home="true">
          <StepLink to={homePath} onClick={trackBreadcrumb}>
            <Icon.Home tabIndex={0} aria-label="clique para ir para a home" size="m" />
          </StepLink>
        </Step>

        {desktop || tracks.length <= 1 ? (
          <Trail
            disabled={disabled}
            trailSteps={previousPaths}
            currentSection={currentPath?.name}
          />
        ) : (
          <BreadcrumbMobile>
            <Trail
              disabled={disabled}
              trailSteps={previousPaths}
              currentSection={currentPath.name}
            />
          </BreadcrumbMobile>
        )}

        {tracks.length > 0 && (
          <Step>
            <Icon.ArrowRight size="m" />
            <Breadcrumbs.LastItemContent
              tabIndex={0}
              aria-current="page"
              data-path={currentPath.name}
              aria-label={`Você está em ${currentPath.name}`}
            >
              {currentPath.name}
            </Breadcrumbs.LastItemContent>
          </Step>
        )}
      </Breadcrumbs.List>
    </Breadcrumbs.Component>
  );
};

export default BreadcrumbBase;
